import { parseMarginPadding, parseResult } from '../controlUtils';

export function displayShapeUtil(obj, entryPoint){

    const content = JSON.parse(obj.Content);
    const type = content.Type;
    const display = content.Display;
    const theme = content.Theme;
    const size = content.Size;
    const label = content.Label;
    const marginPadding = content.MarginPadding;

    const mp = parseMarginPadding(marginPadding);

    const colors = theme.split("-");
    const bgColor = colors[0];
    const txtColor = colors[1];
    const extra1 = colors[2];
    const extra2 = colors[3];
    const extra3 = colors[4];
    
    let shadow = 'none';
    if(display == "default"){ shadow = '0px 4px 10px rgba(0, 0, 0, 0.1)'; }
    else if(display == "plain"){ shadow = 'none'; }

    let width = 0;  let height = 0; let lb = 0; let zoom = 0;
    if(size == "small"){width=100; height=100; lb = 12}
    else if(size == "medium"){width=200; height=200; lb = 13}
    else if(size == "large"){width=300; height=300; lb = 14}
    else if(size == "xlarge"){width=400; height=400; lb = 16}
    else if(size == "xxlarge"){width=500; height=500; lb = 16}

    if(entryPoint == "presentation" && obj.Presentation != ""){
        const ptn = JSON.parse(obj.Presentation);
        if(ptn.TitleSize != "") { lb = parseInt(ptn.TitleSize) }
        if(ptn.TextSize != "") { width = parseInt(ptn.TextSize); height = parseInt(ptn.TextSize) }
        if(ptn.Zoom != "") { zoom = parseInt(ptn.Zoom) }
    }

    const styles = {
        wrap:{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            zoom: `${zoom}%`,
            marginTop: mp.marginTop,
            marginRight: mp.marginRight,
            marginBottom: mp.marginBottom,
            marginLeft: mp.marginLeft,
        },
        rectangle:{
            background: bgColor,
            width: width,
            height: height,
            borderRadius: 5,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            boxShadow: shadow,
            paddingTop: mp.paddingTop,
            paddingRight: mp.paddingRight,
            paddingBottom: mp.paddingBottom,
            paddingLeft: mp.paddingLeft,
        },
        circle:{
            background: bgColor,
            width: width,
            height: height,
            padding: 10,
            borderRadius: '50%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            boxShadow: shadow,
            paddingTop: mp.paddingTop,
            paddingRight: mp.paddingRight,
            paddingBottom: mp.paddingBottom,
            paddingLeft: mp.paddingLeft,
        },
        label:{
            color: txtColor,
            marginBottom: 10,
            fontSize: lb,
            textAlign: 'center',
            fontWeight: 600
        },
    }

    const elem = (
        <div style={styles.wrap}>
            {(type == "rectangle") && 
                <div style={styles.rectangle}>
                    <div style={styles.label}>{label}</div>
                </div>
            }
            {(type == "circle") && 
                <div style={styles.circle}>
                    <div style={styles.label}>{label}</div>
                </div>
            }
        </div>
    )

    return parseResult(elem, obj, entryPoint);

}